import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import GenericError from 'src/component/GenericError';
import useGetCourse from 'src/hook/CourseHook';
import Course from 'src/model/Course';

export interface CourseCardProps {
  courseId: string;
}

export default function CourseCard(props: CourseCardProps) {
  const { courseId } = props;
  const [errorState, setError] = useState(false);
  const courseState: Course = useGetCourse(setError, courseId);

  if (errorState) {
    return <GenericError errorMessage="" />;
  }
  const { image, title, description } = courseState;
  // Use require until app becomes large enough to load images from cdn.
  // eslint-disable-next-line global-require, import/no-dynamic-require
  const courseCardImage = require(`src/${image}`);

  return (
    <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
      <Card sx={{ display: 'flex' }}>
        <CardActionArea component={Link} to={`/course/${courseId}`}>
          <CardMedia component="img" src={courseCardImage} alt="course picture" />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
}
